export const activityLogBlacklist = [
    'hash'
];
